<template>
  <div id="app">
    <div>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
  </div>
  <!-- </form-wizard> -->
</template>

<script>
export default {
  name: "App",
  created() {}
};
</script>
